import React from "react";


export const PickDaySlide = () => {
    return (
        <div className="swiper-container pickslide-today-day">
            <div className="swiper-wrapper">
                <div className="swiper-slide"><span>01</span></div>
                <div className="swiper-slide"><span>02</span></div>
                <div className="swiper-slide"><span>03</span></div>
                <div className="swiper-slide"><span>04</span></div>
                <div className="swiper-slide"><span>05</span></div>
                <div className="swiper-slide"><span>06</span></div>
                <div className="swiper-slide"><span>07</span></div>
                <div className="swiper-slide"><span>08</span></div>
                <div className="swiper-slide"><span>09</span></div>
                <div className="swiper-slide"><span>10</span></div>
                <div className="swiper-slide"><span>11</span></div>
                <div className="swiper-slide"><span>12</span></div>
                <div className="swiper-slide"><span>13</span></div>
                <div className="swiper-slide"><span>14</span></div>
                <div className="swiper-slide"><span>15</span></div>
                <div className="swiper-slide"><span>16</span></div>
                <div className="swiper-slide"><span>17</span></div>
                <div className="swiper-slide"><span>18</span></div>
                <div className="swiper-slide"><span>19</span></div>
                <div className="swiper-slide"><span>20</span></div>
                <div className="swiper-slide"><span>21</span></div>
                <div className="swiper-slide"><span>22</span></div>
                <div className="swiper-slide"><span>23</span></div>
                <div className="swiper-slide"><span>24</span></div>
                <div className="swiper-slide"><span>25</span></div>
                <div className="swiper-slide"><span>26</span></div>
                <div className="swiper-slide"><span>27</span></div>
                <div className="swiper-slide"><span>28</span></div>
                <div className="swiper-slide"><span>29</span></div>
                <div className="swiper-slide"><span>30</span></div>
                <div className="swiper-slide"><span>31</span></div>
            </div>
        </div>
    );
};
